import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1090Status: 'idle',
    startProcess1090Error: undefined as any,
    loadUserParamsProcess1090Status: 'idle',
    loadUserParamsProcess1090Error: undefined as any,

    process1090List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1090 = createAsyncThunk('process1090Slice/startProcess1090', async ({ process1090 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1090/`,
        prepareData(process1090),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1090Status } = getState().process1090Slice
        return startProcess1090Status !== 'pending'
    }
})

export const loadUserParamsProcess1090 = createAsyncThunk('process1090Slice/loadUserParamsProcess1090', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1090/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1090Status } = getState().process1090Slice
        return loadUserParamsProcess1090Status !== 'pending'
    }
})

const Process1090Slice = createSlice({
    name: 'process1090Slice',
    initialState,
    reducers: {
        resetstartProcess1090: (state) => {
            state.job = undefined
            state.startProcess1090Error = undefined
        },
        resetstartProcess1090Error: (state) => {
            state.startProcess1090Error = undefined
        },
        resetloadUserParamsProcess1090: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1090Error = undefined
        },
        resetloadUserParamsProcess1090Error: (state) => {
            state.loadUserParamsProcess1090Error = undefined
        },
        removeFromProcess1090ListById: (state, action) => {
            state.process1090List = state.process1090List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1090ListByIds: (state, action) => {
            state.process1090List = state.process1090List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1090List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1090Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1090List = []
            state.startProcess1090Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1090.pending, (state) => {
            state.startProcess1090Status = 'pending'
            state.startProcess1090Error = undefined
        })
        builder.addCase(startProcess1090.fulfilled, (state, action) => {
            state.startProcess1090Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1090.rejected, (state, action) => {
            state.startProcess1090Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1090Error = action.error.message
            } else {
                state.startProcess1090Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1090.pending, (state) => {
            state.loadUserParamsProcess1090Status = 'pending'
            state.loadUserParamsProcess1090Error = undefined
        })
        builder.addCase(loadUserParamsProcess1090.fulfilled, (state, action) => {
            state.loadUserParamsProcess1090Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1090.rejected, (state, action) => {
            state.loadUserParamsProcess1090Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1090Error = action.error.message
            } else {
                state.loadUserParamsProcess1090Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1090,
    resetstartProcess1090Error,
    resetloadUserParamsProcess1090,
    resetloadUserParamsProcess1090Error,
    removeFromProcess1090ListById,
    removeFromProcess1090ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1090Slice.actions
export default Process1090Slice.reducer
